module.exports = __webpack_public_path__ + "static/puhumalla_parempaa_seksia.bca48cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/puhumalla_parempaa_seksia.jpg
// module id = 840
// module chunks = 129563053867776